import styled from 'styled-components';
import {dFlex, flexWrap, justifyCenter} from '../../../../globalVariables/GlobalFlex';

export const suggestions = styled.div`
    ${dFlex}
    ${flexWrap}
    ${justifyCenter}
    gap: var(--space-sm);
`;
